import React from "react";
import { useSelector } from "react-redux";
import CompanyDetails from "./agency";
import PersonalDetails from "./freelancer";

function UserDetails() {
  const user = useSelector((state) => state.user || {});
  const isAgency = user?.isAgency ?? false;
  return <>{isAgency ? <CompanyDetails /> : <PersonalDetails />}</>;
}

export default UserDetails;
